import  gql  from 'graphql-tag'

export const CREATE_CLIENT_TYPE = gql`mutation clientType($input: ClientTypeMutationInput!){
    clientType(input: $input){
        clientType{
            id
            code
            name
            isActive
        }
        errors{
            field
            messages
        }
    }
}`;